import { render, staticRenderFns } from "./ArtMini.vue?vue&type=template&id=af1495c4&scoped=true&"
import script from "./ArtMini.vue?vue&type=script&lang=js&"
export * from "./ArtMini.vue?vue&type=script&lang=js&"
import style0 from "./ArtMini.vue?vue&type=style&index=0&id=af1495c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1495c4",
  null
  
)

export default component.exports